export default __webpack_public_path__ + "static/media/darkgreen-trane-BA-logo.7d4feba0.svg";